/** Types + empty defaults for Admin Settings (data loads from Formily API). */

export interface SLARule {
  id: string;
  priority: string;
  firstResponseTime: string;
  resolutionTime: string;
  escalationAfter: string;
  enabled: boolean;
}

export interface EscalationMatrix {
  id: string;
  slaPriority: string;
  slaStatus: string;
  escalationTime: string;
  time: string;
  actionType: string;
  notifyRole: string;
  enabled: boolean;
}

export interface BusinessHours {
  id: string;
  workingDays: string;
  startTime: string;
  endTime: string;
  enabled: boolean;
}

export interface TicketCategory {
  id: string;
  name: string;
  description: string;
  ticketCount: number;
  enabled: boolean;
}

export interface AutomationRule {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
}

export const slaRules: SLARule[] = [];
export const escalationMatrix: EscalationMatrix[] = [];
export const businessHours: BusinessHours[] = [];
export const ticketCategories: TicketCategory[] = [];
export const automationRules: AutomationRule[] = [];
